var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c(_setup.UpdateSystem),_c(_setup.Success),_c(_setup.Error),_c(_setup.Loader),_c(_setup.Reauthorization),_c(_setup.PasswordConfirmation),_c(_setup.BlockRole),_c(_setup.BlockUser),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }